import { render } from "./ArrowIcon.vue?vue&type=template&id=5b850cbd&scoped=true"
import script from "./ArrowIcon.vue?vue&type=script&lang=js"
export * from "./ArrowIcon.vue?vue&type=script&lang=js"

import "./ArrowIcon.vue?vue&type=style&index=0&id=5b850cbd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b850cbd"

export default script